module.exports = {
  init: () => {
    var is_device = navigator.userAgent.match(/iPad|Android|webOS|iPhone|iPod|Blackberry/i) != null;

    if ($(".greeter-video").length > 0 && is_device == false) {
      $(window).on("load resize scroll", function() {
        $(".greeter-video").each(function(index, e) {
          let viewportTopPrevious = parseInt($(e).attr("data-viewport-top"), 10) || 0;
          let viewportTop = $(window).scrollTop();
          $(e).attr("data-viewport-top", viewportTop);
          let viewportBottom = viewportTop + $(window).height();
          let distanceTop = $(e).offset().top;
          let inView = Math.max(viewportBottom - distanceTop, 0);
          let inViewPart = Math.min(inView / ($(window).height() * 0.6), 1);
          let played = $(e).hasClass("greeter-video--played") ? true : false;
          if (inViewPart >= 0.5 && viewportTopPrevious < viewportTop && played == false) {
            let movieElement = $(e).find("iframe")[0];
            let newMoviePath = movieElement.src + (movieElement.src.indexOf("?") != -1 ? "&autoplay=1" : "?autoplay=1");
            movieElement.src = newMoviePath;
            $(e).addClass("greeter-video--played");
          }
        });
      });
    }
  }
};
